export const getEpochTime = (createdAt: string) =>
  Math.floor(new Date(createdAt).getTime()).toString();
